// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1qzjy","footer":"ModalError_footer__2RO6I"};